import React from "react";
import { Search, X } from "lucide-react";
import { Option } from "../../constants/enums";

/** Search box for table toolbars */
export function SearchInput({
    value,
    onChange,
    placeholder = "Search…",
}: {
    value: string;
    onChange: (v: string) => void;
    placeholder?: string;
}) {
    return (
        <div className="relative group w-full sm:w-72">
            <Search size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-500 group-focus-within:text-[#8b5cf6] transition-colors" />
            <input
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                className="w-full bg-slate-950/50 border border-slate-800 text-white pl-10 pr-9 py-2.5 rounded-xl text-sm outline-none focus:ring-2 focus:ring-[#8b5cf6]/40 focus:border-[#8b5cf6] transition-all placeholder:text-slate-600"
            />
            {value && (
                <button
                    onClick={() => onChange("")}
                    className="absolute right-2.5 top-1/2 -translate-y-1/2 p-1 text-slate-500 hover:text-white"
                    aria-label="Clear search"
                >
                    <X size={14} />
                </button>
            )}
        </div>
    );
}

/** Compact select for table filters */
export function FilterSelect({
    value,
    onChange,
    options,
    allLabel,
}: {
    value: string;
    onChange: (v: string) => void;
    options: Option[];
    allLabel: string;
}) {
    return (
        <select
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className={`bg-slate-950/50 border text-sm py-2.5 pl-3.5 pr-8 rounded-xl outline-none focus:ring-2 focus:ring-[#8b5cf6]/40 focus:border-[#8b5cf6] transition-all [color-scheme:dark] ${
                value ? "border-[#8b5cf6]/40 text-white" : "border-slate-800 text-slate-400"
            }`}
        >
            <option value="" className="bg-slate-900">
                {allLabel}
            </option>
            {options.map((o) => (
                <option key={o.value} value={o.value} className="bg-slate-900">
                    {o.label}
                </option>
            ))}
        </select>
    );
}

/** Wraps search + filters above a table */
export function Toolbar({ children }: { children: React.ReactNode }) {
    return <div className="flex flex-col sm:flex-row sm:flex-wrap sm:items-center gap-2 p-4 border-b border-slate-800">{children}</div>;
}